import { render, staticRenderFns } from "./GroupsBookings.vue?vue&type=template&id=61314230&scoped=true&"
import script from "./GroupsBookings.vue?vue&type=script&lang=ts&"
export * from "./GroupsBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61314230",
  null
  
)

export default component.exports